import { Component, OnInit } from "@angular/core";
import { logbaseService } from "../../services/logbase.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-po-ledger",
  templateUrl: "./po-ledger.component.html",
  styleUrls: ["./po-ledger.component.scss"]
})
export class PoLedgerComponent implements OnInit {
  datePickerConfig: any;
  dropdownSettings: any;
  suppCodeList: any[];
  supPoint: any;
  selectedDate: any;

  dateNow: Date = new Date("dd/MM/yyyy");
  constructor(private logbaseService: logbaseService, private translate: TranslateService) { }

  ngOnInit() {
    this.datePickerConfig = {
      enableMonthSelector: true
    };
    // Angular2 multi select settings and config
    this.dropdownSettings = {
      idField: 'id',
      textField: 'itemName',
      singleSelection: false,
      text: "Select Supplier Code",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      // classes: "custom-class",
      itemsShowLimit: 3,
      enableCheckAll: true,
      enableSearchFilter: true
    };
    // this.suppCodeList = [
    //   { id: 1, itemName: "S001" },
    //   { id: 2, itemName: "S002" },
    //   { id: 3, itemName: "S003" },
    //   { id: 4, itemName: "S004" },
    //   { id: 5, itemName: "S005" },
    //   { id: 6, itemName: "S006" }
    // ];

    this.getPOSupplierCode();

    this.getAllPoDetails();
  }

  getPOSupplierCode() {
    var suppCodeArr = [];
    this.logbaseService.getPOSupplierCode().subscribe(result => {

      result.response.forEach(function (value, key) {
        suppCodeArr.push({ id: key, itemName: value.supplierCode });
      });
      this.suppCodeList = suppCodeArr;
    });
  }

  getAllPoDetails() {
    // this.logbaseService.getAllPoData().subscribe(result => {
    // });
  }

  getPoForSupp() {
    this.logbaseService.getPODataSupp().subscribe(result => {
    });
  }

  showPoLedger() { }
}
